/**
 * Article FAQ Accordion
 * Handles accordion functionality with smooth animations
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleFAQ);
  } else {
    initArticleFAQ();
  }

  function initArticleFAQ() {
    const accordionContainers = document.querySelectorAll('.js-article-faq-accordion');
    
    if (!accordionContainers.length) return;

    accordionContainers.forEach(function(container) {
      const triggers = container.querySelectorAll('.js-article-faq-trigger');
      
      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', handleAccordionClick);
      });
    });
  }

  function handleAccordionClick(event) {
    event.preventDefault();
    
    const trigger = event.currentTarget;
    const faqItem = trigger.closest('.article-faq__item');
    
    if (!faqItem) return;
    
    const answer = faqItem.querySelector('.article-faq__answer');
    
    if (!answer) return;
    
    const isActive = faqItem.classList.contains('is-active');
    
    // Close all other open items in the same accordion
    const accordionContainer = faqItem.closest('.js-article-faq-accordion');
    if (accordionContainer && !isActive) {
      const allActiveItems = accordionContainer.querySelectorAll('.article-faq__item.is-active');
      allActiveItems.forEach(function(activeItem) {
        if (activeItem !== faqItem) {
          const activeTrigger = activeItem.querySelector('.js-article-faq-trigger');
          const activeAnswer = activeItem.querySelector('.article-faq__answer');
          if (activeTrigger && activeAnswer) {
            closeAccordionItem(activeItem, activeTrigger, activeAnswer);
          }
        }
      });
    }

    // Toggle current item
    if (isActive) {
      closeAccordionItem(faqItem, trigger, answer);
    } else {
      openAccordionItem(faqItem, trigger, answer);
    }
  }

  function openAccordionItem(item, trigger, answer) {
    // Add active class
    item.classList.add('is-active');
    
    // Update ARIA attributes
    trigger.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');
    
    // Calculate and set max-height for smooth animation
    const contentHeight = answer.scrollHeight;
    answer.style.maxHeight = contentHeight + 'px';
    
    // Trigger reflow to ensure animation plays
    void answer.offsetHeight;
  }

  function closeAccordionItem(item, trigger, answer) {
    // Set current height before closing for smooth animation
    answer.style.maxHeight = answer.scrollHeight + 'px';
    
    // Trigger reflow
    void answer.offsetHeight;
    
    // Remove active class
    item.classList.remove('is-active');
    
    // Update ARIA attributes
    trigger.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    
    // Reset max-height with slight delay to ensure animation
    requestAnimationFrame(function() {
      answer.style.maxHeight = '0';
    });
  }

  // Close accordion on ESC key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      const activeItems = document.querySelectorAll('.article-faq__item.is-active');
      activeItems.forEach(function(item) {
        const trigger = item.querySelector('.js-article-faq-trigger');
        const answer = item.querySelector('.article-faq__answer');
        if (trigger && answer) {
          closeAccordionItem(item, trigger, answer);
        }
      });
    }
  });

  // Re-calculate heights on window resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const activeAnswers = document.querySelectorAll('.article-faq__item.is-active .article-faq__answer');
      activeAnswers.forEach(function(answer) {
        if (answer.scrollHeight > 0) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    }, 250);
  });

  // Handle orientation change on mobile
  window.addEventListener('orientationchange', function() {
    setTimeout(function() {
      const activeAnswers = document.querySelectorAll('.article-faq__item.is-active .article-faq__answer');
      activeAnswers.forEach(function(answer) {
        if (answer.scrollHeight > 0) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    }, 300);
  });

})();
